import { Injectable } from "@angular/core";
import { AuthenticationService } from "@shared/services/authentication.service";
import * as moment from "moment";
declare const mixpanel;
@Injectable()
export class MixpanelEventLoggingService {
  constructor(private authenticationService: AuthenticationService) {}

  dispatchEvent(eventName: string, data) {
    const commonDetails = this.authenticationService.getCommonUserDetails();
    if (commonDetails) {
      data = Object.assign({ EventName: eventName }, data, commonDetails);
    } else {
      data = Object.assign({ EventName: eventName }, data);
    }
    mixpanel.track(eventName, data);
  }
  loginDispatchEvent(user) {
    mixpanel.identify(user.id);
    const panelObj = {
      "USER_ID": user != null ? user.id : '',
      "name": user != null ? user.firstName + ' ' + user.lastName : '',
      "email": user != null ? user.email : '',
      "User Role": (user != null && user.roles.length > 0) ? user.roles[0].code : '',
      "Organization": ( user != null && user.organization != null ) ? user.organization.name : '',
      "Sign up date": new Date()
    };
    if (user != null && user.roles.length > 0 && user.roles[0].code === "tech_buyer") {
      panelObj["Line Of Business"] = user.lineOfBusiness != null ? user.lineOfBusiness.lineOfBusiness : '';
      panelObj["Job Title"] = user.jobTitle != null ? user.jobTitle.jobTitle : '';
      panelObj["Employee Size"] = (user.techbuyerOrganization != null &&
        user.techbuyerOrganization.employeeSize != null) ? user.techbuyerOrganization.employeeSize.employeeSizeFrom +
        ' - ' + user.techbuyerOrganization.employeeSize.employeeSizeTo : '';
      panelObj["Industry"] = user.industry != null ? user.industry.industryName : '';
      panelObj["itBudget"] = (user.techbuyerOrganization != null && user.techbuyerOrganization.itBudget != null)
      ? user.techbuyerOrganization.itBudget.itBudgetFrom + ' - ' + user.techbuyerOrganization.itBudget.itBudgetTo : ' ';
      panelObj["revenue"] = ( user.techbuyerOrganization != null && user.techbuyerOrganization.revenue != null )
      ? user.techbuyerOrganization.revenue.revenueFrom + ' - ' + user.techbuyerOrganization.revenue.revenueTo : ' ';
    }
    if (user != null && user.roles.length > 0 && user.roles[0].code === "tech_analyst") {
      panelObj["Skills"] = user.skills != null ?
      Array.prototype.map.call(user.skills, function(item) { return item.skill; }).join(', ') : '';
      panelObj["Followers"] = user.followers != null ?
      Array.prototype.map.call(user.followers, function(item) { return item.user.firstName + item.user.lastName ; }).join(', ') : '';
      if ( user.timeDetails != null ) {
        let totalWorkingHours = 0;
        const timeDetails =  user['timeDetails'];
        if (timeDetails != null && timeDetails.analystTimings != null &&  timeDetails.analystTimings.length > 0 ) {
          for (let i = 0 ; i <  timeDetails.analystTimings.length ; i ++) {
            const day =  timeDetails.analystTimings[i];
            if (day != null && day.startTime !== '00:00:00+00' && day.endTime !== '23:30:00+00' ) {
              const b = moment( day.startTime, "HH:mm:ss+00") ;
              const a = moment(day.endTime, "HH:mm:ss+00") ;
              totalWorkingHours += a.diff(b, 'hours') ;

            }
          }
        }
        panelObj["Total Weekly Working Hours"] = totalWorkingHours ;
    }
    }
    mixpanel.people.set(panelObj);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/mixpanel-event-logging.service.ts